export default __webpack_public_path__ + "static/media/ezclothing.587aec5e.svg";